export default "__VITE_PUBLIC_ASSET__19145ec7__"